function NotFound() {
  return (
    <div className="title">
      <p>404 Not Found</p>
    </div>
  );
}

export default NotFound;
